/***
 * Created on 2023/8/24
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import CurrentTwoStep from "./current_two_step";
import TwoStepOptions from "./two_step_options";


function ManageTwoStep({dispatch, state}) {
    return (
        <>
            <CurrentTwoStep dispatch={dispatch} state={state}/>
            <TwoStepOptions dispatch={dispatch} state={state}/>
        </>
    );
}

export default ManageTwoStep;